import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { ThemeProvider } from './hooks/useTheme';
import { ToastProvider } from './contexts/ToastContext';
import './index.css';

const initAnalytics = () =>
  import('./lib/analytics').then((m) => m.initAnalytics());
if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(initAnalytics, { timeout: 2000 });
} else {
  setTimeout(initAnalytics, 2000);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <HelmetProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </HelmetProvider>
    </ThemeProvider>
  </StrictMode>,
);
